import React from "react";
import { Card } from "../../../components/ui/Card";
import BatchStatusBadge from "./BatchStatusBadge";
import BatchProgressBar from "./BatchProgressBar";
import BatchRowActions from "./BatchRowActions";

/**
 * Compact card representation of a batch row, used on small screens where a
 * wide table doesn't fit. Mirrors the columns shown in BatchTable.
 */
const BatchCard = ({ batch, onDownload, downloadDisabled, onView, onEdit, onDispatch, onDelete }) => (
  <Card
    className="cursor-pointer px-4 py-3.5 transition-shadow hover:shadow-md"
    onClick={onView}
  >
    <div className="flex items-start justify-between gap-3">
      <div className="min-w-0">
        <p className="truncate text-sm font-semibold text-slate-900">{batch.batchId}</p>
        <p className="truncate text-xs text-slate-500">{batch.partLabel}</p>
      </div>
      <BatchStatusBadge status={batch.status} />
    </div>

    <div className="mt-3 grid grid-cols-2 gap-2 text-xs text-slate-500">
      <div>
        <p className="text-[11px] uppercase tracking-wide text-slate-400">Qty</p>
        <p className="text-sm font-medium text-slate-700">{batch.quantity ?? "-"}</p>
      </div>
      <div>
        <p className="text-[11px] uppercase tracking-wide text-slate-400">Created On</p>
        <p className="text-sm font-medium text-slate-700">{batch.createdOnLabel}</p>
      </div>
    </div>

    <div className="mt-3">
      <p className="mb-1 text-[11px] uppercase tracking-wide text-slate-400">Progress</p>
      <BatchProgressBar progress={batch.progress} status={batch.status} />
    </div>

    <div className="mt-3 flex justify-end border-t border-slate-100 pt-2.5">
      <BatchRowActions
        onDownload={onDownload}
        downloadDisabled={downloadDisabled}
        onView={onView}
        onEdit={onEdit}
        onDispatch={onDispatch}
        onDelete={onDelete}
      />
    </div>
  </Card>
);

export default BatchCard;
